itsoftApp.createModule("hiddenLabel", function() {
    var module = this;

    var hidingLabelsForm = document.querySelectorAll(".js-hiding-labels");

    var initHidingLabels = function(form) {
        var inputs = form.querySelectorAll(".form__input");

        var onFieldInput = function(evt) {
            if (evt.target.value === '') {
                if (evt.target.classList.contains("form__input--filled")) {
                    evt.target.classList.remove("form__input--filled");
                }
            } else if (!(evt.target.classList.contains("form__input--filled"))) {
                evt.target.classList.add("form__input--filled");
            }
        };

        var addInputListener = function(input) {
            input.addEventListener("input", onFieldInput);
            input.addEventListener("blur", onFieldInput);
        };

        for (var i = 0; i < inputs.length; i++) {
            addInputListener(inputs[i]);

            if (inputs[i].value) {
                inputs[i].classList.add("form__input--filled");
            }
        }
    };

    if (hidingLabelsForm) {
        for (var i = 0; i < hidingLabelsForm.length; i++) {
            initHidingLabels(hidingLabelsForm[i]);
        }
    }

    module.callback = initHidingLabels;
});